var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboDuplicateSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6112 11.8888H13.0557V10.3332H13.4446V9.94434H15.0001V11.4999C15.0001 11.7177 14.829 11.8888 14.6112 11.8888Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8892 10.3333V11.8888H12.278V10.3333H11.8892Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11133 3.72217V4.11106H5.66688V3.72217H4.11133Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66688 2.94444H4.11133V1.38889C4.11133 1.17111 4.28244 1 4.50022 1H6.05577V2.55556H5.66688V2.94444Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2779 2.55556H9.94461V1H12.2779V2.55556ZM9.16683 2.55556H6.8335V1H9.16683V2.55556Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.94444H13.4446V2.55556H13.0557V1H14.6112C14.829 1 15.0001 1.17111 15.0001 1.38889V2.94444Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 9.16661H13.4448V6.83328H15.0004V9.16661ZM15.0004 6.0555H13.4448V3.72217H15.0004V6.0555Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.49997V14.6111C1 14.8289 1.17111 15 1.38889 15H11.5C11.7178 15 11.8889 14.8289 11.8889 14.6111V4.49997C11.8889 4.2822 11.7178 4.11108 11.5 4.11108H1.38889C1.17111 4.11108 1 4.2822 1 4.49997ZM10.3333 13.4444H2.55556V5.66664H10.3333V13.4444Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77799 9.16661V9.94439C8.77799 10.1622 8.60688 10.3333 8.38911 10.3333H7.22244V11.4999C7.22244 11.7177 7.05133 11.8888 6.83355 11.8888H6.05577C5.83799 11.8888 5.66688 11.7177 5.66688 11.4999V10.3333H4.50022C4.28244 10.3333 4.11133 10.1622 4.11133 9.94439V9.16661C4.11133 8.94883 4.28244 8.77772 4.50022 8.77772H5.66688V7.61106C5.66688 7.39328 5.83799 7.22217 6.05577 7.22217H6.83355C7.05133 7.22217 7.22244 7.39328 7.22244 7.61106V8.77772H8.38911C8.60688 8.77772 8.77799 8.94883 8.77799 9.16661Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboDuplicateSmall);
export default __webpack_public_path__ + "static/media/FBODuplicateSmall.7e300fe6907458afebb756accb112d5e.svg";
export { ForwardRef as ReactComponent };